<template>
    <div class="about__list">
        <div class="about__item">
            <div class="about__item-table">
                <div class="about__item-table__column instant header">
                    <template v-for="(head, index) in dataSource.header" :key="index">
                        <div class="about__item-table__column-item">
                            <span class="about__item-table__column-item-text">
                                {{ getTranslatedText(head.title) }}
                            </span>
                        </div>
                    </template>
                </div>

                <div class="about__item-table__column full">
                    <template v-for="(body, index) in dataSource.body" :key="index">
                        <div class="about__item-table__column instant">
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{ body.match }}
                                </span>
                            </div>
                            <div class="about__item-table__column-item">
                                <span class="about__item-table__column-item-text">
                                    {{
                                        getTranslatedText(body.prize, {
                                            symbol: $store.state.config.setup?.symbol,
                                        })
                                    }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import { lottoInstant } from '@/resource/about/loto';

export default {
    mixins: [languageMixins],
    data() {
        return {
            dataSource: lottoInstant,
        };
    },
};
</script>
